import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import CallUs from "../assets/images/contact-us/CallUs.svg";
import SendUsEmail from "../assets/images/contact-us/SendUsEmail.svg";
import ForInquiries from "../assets/images/contact-us/ForInquiries.svg";
import EmailIcon from "../assets/images/contact-us/mail-icon.svg";
import PhoneIcon from "../assets/images/contact-us/phone-icon.svg";
import SendIcon from "../assets/images/contact-us/send-icon.svg";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Skeleton from "react-loading-skeleton";

import { useDispatch, useSelector } from "react-redux";
import {
  createContactInquiry,
  clearMessages,
} from "../features/visitor/visitorActions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify"; // Import toast
import { formatPhoneNumber } from "../helpers/helpers";

function ContactUsComp(pageResponse) {
  const [contactUsData, setContactUsData] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [showForm, setShowForm] = useState(false);

  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector(
    (state) => state.visitor,
  );

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    setPhone(formatPhoneNumber(value));
  };

  const validate = () => {
    const errors = {};

    // Check for empty fields
    if (!firstName) errors.firstName = "First Name is required.";
    if (!lastName) errors.lastName = "Last Name is required.";
    if (!email) errors.email = "Email is required.";
    if (!phone) errors.phone = "Phone Number is required.";
    if (!description) errors.description = "Description is required.";

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email))
      errors.email = "Invalid email format.";

    if (phone && phone.length !== 12)
      errors.phone = "Please enter valid phone number.";

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Initial blank errors
    setErrors({});

    // Validate form inputs
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Dismiss any currently visible toasts
    toast.dismiss();

    // Dispatch registration action
    let data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      mobile_number: phone,
      description: description,
    };

    dispatch(createContactInquiry(data));
  };

  // Show success and error toasts
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, {
        autoClose: 5000,
        hideProgressBar: true,
        className: "toast-success",
      });
      dispatch(clearMessages()); // Reset the messages after showing the toast
      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setDescription("");
      setErrors({});
    }
    if (errorMessage) {
      toast.error(errorMessage, {
        autoClose: 5000,
        hideProgressBar: true,
        className: "toast-error",
      });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [successMessage, errorMessage, dispatch]);

  useEffect(() => {
    if (pageResponse?.pageResponse) {
      let conData = pageResponse?.pageResponse?.contact_us_section;
      if (conData) {
        try {
          conData = JSON.parse(conData);
          setContactUsData(conData);
        } catch (error) {
          console.error("Failed to parse contact data:", error);
        }
      }
    }
  }, [pageResponse?.pageResponse]);

  return (
    <>
      <section className="contact-us">
        <div className="common-header">
          <h2>{contactUsData?.title}</h2>
          <p>{contactUsData?.description}</p>
        </div>
        <div className="contact-us-main">
          {loading ? (
            <Row>
              {
                // Show 3 skeleton loader boxes when loading
                Array(3)
                  .fill(0)
                  .map((_, index) => (
                    <Col lg="4" className="mb-4 mb-lg-0" key={index}>
                      <div className="contact-us-box">
                        <div className="contact-us-box-img">
                          <Skeleton height={100} width={100} />
                        </div>
                        <div className="contact-us-box-info">
                          <h3>
                            <Skeleton width={100} />
                          </h3>
                          <p>
                            <Skeleton width={250} />
                          </p>
                          <p>
                            <Skeleton width={120} />
                          </p>
                          <p className="strong">
                            <Skeleton width={100} />
                          </p>
                          <Skeleton width={100} height={40} />
                        </div>
                      </div>
                    </Col>
                  ))
              }
            </Row>
          ) : (
            <Row>
              <Col lg="6" className="mb-4 mb-lg-0">
                <div className="contact-us-box">
                  <div className="contact-us-box-img">
                    <img src={CallUs} alt="" />
                  </div>
                  <div className="contact-us-box-info">
                    <h3>Call Us</h3>
                    <p>{contactUsData?.call_us_title}</p>
                    <a
                      href={`tel:${contactUsData?.call_us_no}`}
                      className="phone-number"
                    >
                      {contactUsData?.call_us_no}
                    </a>
                    <p className="strong">{contactUsData?.call_us_time}</p>
                    <a
                      href={`tel:${contactUsData?.call_us_no}`}
                      className="cutsom-bttn"
                      title=""
                    >
                      <img src={PhoneIcon} alt="" /> Call Now
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg="6" className="mb-4 mb-lg-0">
                <div className="contact-us-box">
                  <div className="contact-us-box-img">
                    <img src={SendUsEmail} alt="" />
                  </div>
                  <div className="contact-us-box-info">
                    <h3>Send Us an Email</h3>
                    <p>{contactUsData?.email_us_title}</p>
                    <p className="strong">{contactUsData?.email_us_time}</p>
                    <a
                      href="#contact-form"
                      className="cutsom-bttn"
                      title=""
                      onClick={(e) => {
                        e.preventDefault();
                        setShowForm((prev) => !prev);
                      }}
                    >
                      <img src={EmailIcon} alt="" />{" "}
                      {showForm ? "Hide Form" : "Email Now"}
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div>
        {showForm && (
          <div id="contact-form" className="contact-us-form">
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-4" controlId="formFirstName">
                    <Form.Label>
                      First Name <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      isInvalid={!!errors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.firstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md="6">
                  <Form.Group className="mb-4" controlId="formLastName">
                    <Form.Label>
                      Last Name <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      isInvalid={!!errors.lastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.lastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                
                <Col md="6">
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Label>
                      Email Address <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group
                    className="mb-4"
                    controlId="formBasicPhoneNumbber"
                  >
                    <Form.Label>
                      Phone Number <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Phone Number"
                      maxLength={12}
                      value={phone}
                      onChange={handlePhoneChange}
                      //onChange={(e) => setPhone(e.target.value)}
                      isInvalid={!!errors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md="12">
                  <Form.Group className="mb-3" controlId="formDescription">
                    <Form.Label>
                      Description <span>*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Write here..."
                      rows={3}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      isInvalid={!!errors.description}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.description}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <p className="note">
                    *PLEASE NOTE : We are not able to discuss medical
                    conditions, prescription medication or possible medication
                    interactions. We strongly encourage you to speak with a
                    nutritionally informed physician or pharmacist regarding
                    possible medication and supplement interactions.
                  </p>

                  <Button
                    className="cutsom-bttn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        size="lg"
                        className="spinner-icon"
                      />
                    ) : (
                      <>
                        <img src={SendIcon} alt="Send" /> Submit
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </section>
    </>
  );
}
export default ContactUsComp;
